import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import NewsTableFilters from "components/subComponents/NewsTableFilters";

import useNewsList from "hooks/list/useNewsList";

function ElencoNews() {
    const newsListHook = useNewsList();

    const { navigateToNewNews, alertConfirmHook, dataTableHook } = newsListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <NewsTableFilters newsListHook={newsListHook} />

                <DataTableSimple dataTableHook={dataTableHook} dontUsePaper />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewNews}>
                        Nuova News
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoNews;
